import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import BottomNav   from './BottomNav';

export default function AppLayout() {
  return (
    <div className="app-shell flex flex-col pb-20">
      <AdminHeader />
      <Outlet />
      <BottomNav />
    </div>
  );
}
